export enum StatusEnum {
  PREPARE = 'PREPARE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESSS',
  ERROR = 'ERROR',
}

export enum InfoTextEnum {
  NO_PROGRESS = 'На данный момент Вы не добавили ни одного достижения.',
  NO_KIDS = 'На данный момент у Вас не зарегистрировано ни одного обучающегося.',
}

export interface IProgress {}



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/types.ts